import { Popover } from 'bootstrap';

document.addEventListener('turbolinks:load', () => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  tooltipTriggerList.map((tooltipTriggerEl) => new Popover(tooltipTriggerEl));
});
